import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "treatment-detail-selector",
  class: "mx-auto h-full w-full max-w-screen-md flex flex-col"
}
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between items-center mb-2"
}
const _hoisted_3 = { class: "text-h6 text-gray-800 w-3/4" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 pt-4 mb-4" }
const _hoisted_5 = { class: "admin-options-wrapper" }
const _hoisted_6 = { class: "w-full overflow-y-scroll px-4 fixedScrollable" }
const _hoisted_7 = { class: "px-4 mb-3" }
const _hoisted_8 = { class: "room-options-wrapper" }
const _hoisted_9 = { class: "w-full overflow-y-scroll px-4 fixedScrollable" }
const _hoisted_10 = { class: "w-full flex justify-center px-2 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_TextCard = _resolveComponent("TextCard")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.selectedTreatment && _ctx.doctors)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.customTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedTreatment.name), 1),
              _createVNode(_component_v_btn, {
                class: "",
                color: "gray-50",
                icon: "mdi-close",
                variant: "text",
                density: "compact",
                onClick: _ctx.handleClearTreatment
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-button mb-4 pt-2" }, " SELECT A PRACTITIONER ", -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDoctors, (admin) => {
                  return (_openBlock(), _createBlock(_component_TextCard, {
                    key: `admin-${admin.uuid}`,
                    class: "w-full mb-2 cursor-pointer",
                    initialsColor: admin.color,
                    initials: _ctx.$filters.initials(admin.name),
                    selected: _ctx.selectedAdmin === admin.uuid,
                    text: admin.name,
                    onClick: ($event: any) => (_ctx.handleSelectItem('selectedAdmin', admin.uuid))
                  }, null, 8, ["initialsColor", "initials", "selected", "text", "onClick"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                variant: "text",
                density: "comfortable",
                class: "align-center",
                color: "#7f7f7f",
                onClick: _ctx.onShowSettings
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "Practitioner settings", -1)),
                  _createVNode(_component_v_icon, {
                    class: "ml-2",
                    color: "gray"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-cog", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-button mb-4 pt-2" }, " SELECT A TIME ", -1)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 15, 30, 45, 60], (time, i) => {
                return _createVNode(_component_TextCard, {
                  key: `time-card-${i}`,
                  class: "w-full mb-2 cursor-pointer",
                  selected: _ctx.selectedTime === time,
                  text: `${time} Min`,
                  onClick: ($event: any) => (_ctx.selectTime(time))
                }, null, 8, ["selected", "text", "onClick"])
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            class: "mr-6",
            color: "primary",
            disabled: _ctx.addTreatmentButtonIsDisabled,
            onClick: _ctx.handleAddTreatment
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" ADD TREATMENT ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            class: "ml-6",
            color: "gray-lighten-2",
            onClick: _ctx.handleClearTreatment
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" CLOSE ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}